// extracted by mini-css-extract-plugin
module.exports = {"pdpBreadcrumbContainer":"ArtDetail2_pdpBreadcrumbContainer__S7F2N","adminPanelContainer":"ArtDetail2_adminPanelContainer__pHHuh","leftToRight":"ArtDetail2_leftToRight__QTi9t"};